'use client';

import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { STATIC_HOTEL_INFORMATION_QUERY } from '@whitbread-eos/api';
import { useRouter } from 'next/router';
import { getStaticHotelInformationQueryDateDataFromUrl } from '../getters';
import useCustomLocale from './use-custom-locale';
import { useQueryRequest } from './use-request';
export default function useStaticHotelInformation() {
  var _router$asPath$split$, _router$asPath;
  var router = useRouter();
  var slug = ['/hotels', ...router.query.slug].join('/');
  var _useCustomLocale = useCustomLocale(),
    country = _useCustomLocale.country,
    language = _useCustomLocale.language;
  var queryString = (_router$asPath$split$ = (_router$asPath = router.asPath) === null || _router$asPath === void 0 ? void 0 : _router$asPath.split('?')[1]) !== null && _router$asPath$split$ !== void 0 ? _router$asPath$split$ : '';
  var _getStaticHotelInform = getStaticHotelInformationQueryDateDataFromUrl(queryString),
    staticHotelInformationQueryKeyDates = _getStaticHotelInform.staticHotelInformationQueryKeyDates,
    staticHotelInformationQueryPayloadDates = _getStaticHotelInform.staticHotelInformationQueryPayloadDates;
  var _useQueryRequest = useQueryRequest(['staticHotelInformation', language, country, slug, ...staticHotelInformationQueryKeyDates], STATIC_HOTEL_INFORMATION_QUERY, _objectSpread({
      slug,
      language,
      country
    }, staticHotelInformationQueryPayloadDates)),
    isLoading = _useQueryRequest.isLoading,
    isError = _useQueryRequest.isError,
    data = _useQueryRequest.data,
    error = _useQueryRequest.error;
  var hotelInformationData = data === null || data === void 0 ? void 0 : data.hotelInformationBySlug;
  return _objectSpread(_objectSpread({
    isLoading,
    isError
  }, hotelInformationData), {}, {
    error
  });
}